// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import aiEntity from './entities/ai.json';
import aiMenu from '../pages/ai/menu.json';
import aiFullForm from '../pages/ai/forms/full.json';
import aiContextForm from '../pages/ai/forms/context.json';
import aiMiniForm from '../pages/ai/forms/mini.json';
import aiLookupForm from '../pages/ai/forms/lookup.json';
import aiTableView from '../pages/ai/views/table.json';
import aiStagesView from '../pages/ai/views/stages.json';
import aiCardsView from '../pages/ai/views/cards.json';
import aiInlineView from '../pages/ai/views/inline.json';
import aiBacklogView from '../pages/ai/views/backlog.json';
import aiSplitView from '../pages/ai/views/split.json';
import aiCalendarView from '../pages/ai/views/calendar.json';
import aiDashboardView from '../pages/ai/views/dashboard.json';

/** Тип запису «Запит до ШІ» зі сторінками пакета: меню, форми та подання з pages/ai/. */
export const aiDefinition: IRecordTypeDefinition = {
  ...aiEntity,
  views: assembleViewSet({
      table: aiTableView,
      stages: aiStagesView,
      cards: aiCardsView,
      inline: aiInlineView,
      backlog: aiBacklogView,
      split: aiSplitView,
      calendar: aiCalendarView,
      dashboard: aiDashboardView,
  }),
  form: aiFullForm,
  forms: { full: aiFullForm, context: aiContextForm, mini: aiMiniForm, lookup: aiLookupForm },
  menu: aiMenu,
} as IRecordTypeDefinition;
